import styled from 'styled-components';

export default function PaymentOptionCustomInput(props) {
  const { value, setValue, placeholder, width, disabled, textAlign, index, isFlex = false } = props;

  function handleClick(e) {
  }

  function handleChange(e) {
    const inputValue = e.target.value;
    if (inputValue === '' || /^[0-9][0-9,]*$/.test(inputValue)) {
      setValue(inputValue, index);
    }
  }

  function handleFocus(e) {
    if (value === '0') setValue('', index);
  }

  function handleBlur(e) {
  }

  return (
    <Input
      type='text'
      disabled={disabled}
      placeholder={placeholder}
      value={value}
      textAlign={textAlign}
      width={width}
      isFlex={isFlex}
      onClick={handleClick}
      onChange={handleChange}
      onFocus={handleFocus}
      onBlur={handleBlur} />
  )
}

const Input = styled.input`
	font-family: NotoSansKR-Regular;
	font-size: 14px;
	line-height: 20px;

	width: ${props => props.width ? `${props.width}px` : props.isFlex ? undefined : '100%'};
  flex: ${props => props.isFlex ? 1 : undefined};
  min-width: ${props => props.isFlex ? '0' : undefined};
	height: 30px;

	padding: 0 8px;

	outline: none;
	border: 1px solid ${props => props.disabled ? props.theme.background : props.theme.line};
	border-radius: 5px;
	color: ${props => props.theme.text};
	background-color: ${props => props.theme.subBackground};

  text-align: ${props => props.textAlign};
  pointer-events: ${props => props.disabled ? 'none' : 'auto'};

	::placeholder {
		color: ${props => props.theme.subText};
	}

  &:disabled {
    background-color: ${props => props.theme.buttonFill};
    border-color: ${props => props.theme.buttonFill};
    color: ${props => props.theme.subText};
    cursor: not-allowed;
  }
	
  transition: all 0.3s ease-in-out;
`;